import { SocialAccountProvider } from "@/types"

export const PREFERS_URL_OVER_USERNAME: SocialAccountProvider[] = ["vimeo"]
